// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-l_hi","advertDetailService__price":"c-l_hj"};